const state = {
  searchText: '',
  searchOpen: false,
  searchObject: {},
  searchCriteria: {
    'in:': 'views',
    // 'of:' : 'groups',
    // '#': 'labels',
    'label:': 'labels',
    'is:': 'is',
    'on:': 'on',
    'ext:': 'extensions',
    'to:': 'to',
    'from:': 'from',
    'before:': 'before',
    'after:': 'after',
    // 'has:' : 'has',
    'answer:': 'answers',
    'filetype:': 'filetypes',
    'group:': 'group'
  },
  propositions: []
}

const mutations = {
  setNewText (state, searchText) {
    state.searchText = searchText
  },
  setEmptySearchObject (state) {
    let obj = {
      // array of string : free texts in search (not associated to an entry)
      texts: [],
      // string : last token parsed
      lastToken: '',
      // boolean : true if search is not empty
      isActive: false,
      // string : last entry with no defined value (xxx:)
      lastEntry: null,
      // string : value
      entryValue: '',
      // string : set to last entry (xxx:) not ended (xxx: sfsd)
      inEntry: null,
      // object
      keys: {}
    }
    for (let keyword in state.searchCriteria) {
      let entry = state.searchCriteria[keyword]
      obj.keys[entry] = []
    }
    state.searchObject = obj
  },
  setPropositions (state, propositions) {
    state.propositions = propositions
  },
  selectProposition (state, proposition) {
    state.searchText = proposition.transform(state.searchText)
    proposition.onSelect()
  }
}

mutations.setEmptySearchObject(state)

const actions = {
  toggleOpen (ctx) {
    ctx.state.searchOpen = !ctx.state.searchOpen
  },
  open (ctx) {
    ctx.state.searchOpen = true
  },
  close (ctx) {
    ctx.state.searchOpen = false
  },
  clear (ctx) {
    ctx.commit('setEmptySearchObject')
  },
  setNewText (ctx, searchText) {
    // 1) use regex to extract double quoted string (ex: "Olivier Markowitch") into quotedStrings
    ctx.commit('setNewText', searchText)
    let regex = /"([^"]*)"/g
    let quotedStrings = []
    let tokenForQuotedString = '{{$}}'
    let t
    while ((t = regex.exec(searchText)) != null) {
      quotedStrings.push(t[1])
    }

    // 2) replace all double quoted string by {{$}}
    searchText = searchText.replace(/"([^"]*)"/g, tokenForQuotedString)

    // split text in tokens
    let textParts = searchText.split(/[\s]+/)

    let keywordsAndEntries = state.searchCriteria

    ctx.commit('setEmptySearchObject')
    let searchObject = ctx.state.searchObject

    textParts.forEach((part) => {
      part = part.trim()

      // replace {{$}} by origin double quoted string
      while (part.indexOf(tokenForQuotedString) > -1 && quotedStrings.length > 0) {
        let replaceString = quotedStrings.splice(0, 1)
        if (replaceString.length > 0) {
          part = part.replace(tokenForQuotedString, replaceString)
        }
      }

      if (searchObject.lastEntry == null) {
        searchObject.inEntry = null
      }
      if (part.length === 0) {
        return
      }
      let found = false
      for (let keyword in keywordsAndEntries) {
        let entry = keywordsAndEntries[keyword]
        if (part.indexOf(keyword) === 0 && part.length >= keyword.length) {
          searchObject.lastEntry = entry
          searchObject.inEntry = entry
          searchObject.entryValue = ''
          found = true
          if (part.length > keyword.length) {
            searchObject.keys[entry].push(part.substr(keyword.length))
            searchObject.entryValue = part.substr(keyword.length)
            searchObject.lastEntry = null
            searchObject.isActive = true
          }
          continue
        }
      }
      if (!found) {
        let lastEntry = searchObject.lastEntry
        if (lastEntry == null) {
          searchObject.texts.push(part)
          searchObject.entryValue = ''
          searchObject.isActive = true
        } else {
          searchObject.keys[lastEntry].push(part)
          searchObject.entryValue = part
          searchObject.lastEntry = null
          searchObject.isActive = true
        }
      }
      searchObject.lastToken = part
    })
  },
  setPropositions (ctx, propositions) {
    ctx.commit('setPropositions', propositions)
  },
  selectProposition (ctx, proposition) {
    ctx.commit('selectProposition', proposition)
    ctx.dispatch('setNewText', ctx.state.searchText)
    ctx.dispatch('open')
  }
}

const getters = {
  searchText (state) {
    return state.searchText
  },
  searchOpen (state) {
    return state.searchOpen
  },
  searchObject (state) {
    return state.searchObject
  },
  propositions (state) {
    return state.propositions
  },
  searchKeyedValues (state) {
    return function (key) {
      return (state.searchObject.keys && state.searchObject.keys[key]) || []
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/search.js